// extracted by mini-css-extract-plugin
export default {"pageTitle":"result_pageTitle__bpNfJ","resultWon":"result_resultWon__xGRDQ","resultLost":"result_resultLost__sR-SX"};